import { render, staticRenderFns } from "./SessionHistoryView.vue?vue&type=template&id=3e50e84c&scoped=true&"
import script from "./SessionHistoryView.vue?vue&type=script&lang=js&"
export * from "./SessionHistoryView.vue?vue&type=script&lang=js&"
import style0 from "./SessionHistoryView.vue?vue&type=style&index=0&id=3e50e84c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e50e84c",
  null
  
)

export default component.exports